import React, { FC } from 'react';

import { Filter, FilterProps, TextInput } from 'react-admin';

export const UniversityFilter: FC<Omit<FilterProps, 'children'>> = props => (
  <Filter {...props}>
    <TextInput alwaysOn label="Name" source="name_istartswith" />
    <TextInput alwaysOn label="Domain" source="domain_istartswith" />
  </Filter>
);
